export default [
  {
    title: "داشبورد",
    route: "home",
    icon: "HomeIcon",
  },
  {
    title: "گزارش‌ها",
    icon: "PieChartIcon",
    children: [
      {
        title: "تمدید و ارتقاء اشتراک",
        route: "subscriptionHistory",
      },
      {
        title: "شارژ حساب پیامکی",
        route: "smsChargesHistory",
      },
      {
        title: "سفارشات صندوق",
        route: "sales-report",
      },
      {
        title: "سفارشات آنلاین",
        route: "online-orders",
      },
      {
        title: "فروش کل",
        route: "total-sale",
      },
      {
        title: "مشتریان",
        route: "customers",
      },
      {
        title: "پیامک های ارسالی",
        route: "sms-sent-messages",
      },
    ],
  },
  {
    title: "تایید محتوا",
    icon: "ImageIcon",
    children: [
      {
        title: "محصولات",
        route: "acceptContentProducts",
      },
      {
        title: "مجموعه",
        route: "acceptContentStores",
      },
      {
        title: "باشگاه مشتریان",
        route: "acceptContentClub",
      },
      {
        title: "تصاویر درباره ما",
        route: "acceptContentPictures",
      },
      {
        title: "دسته بندی",
        route: "acceptContentCategories",
      },
      {
        title: "پیامک گروهی",
        route: "sending-group-sms",
      },
    ],
  },
  {
    title: "تنظیمات",
    icon: "SettingsIcon",
    children: [
      {
        title: "اشتراک ها",
        route: "subscriptions",
      },
      {
        title: "ویژگی ها",
        route: "features",
      },
      {
        title: "پیامک ها",
        route: "smsManagement",
      },
      {
        title: "آیکون ها",
        route: "categoryIcon",
      },
    ],
  },

  {
    title: "اطلاعات درگاه مجموعه ها",
    route: "economic-info",
    icon: "DollarSignIcon",
  },

  {
    title: "ایجاد مجموعه",
    route: "createStore",
    icon: "UserPlusIcon",
  },

  {
    title: "مدیر سیستم",
    route: "system-manager",
    icon: "CpuIcon",
  },
  {
    title: "پشتیبانی",
    route: "tickets",
    icon: "UsersIcon",
  },
];
